import Axios from '../utils/axios-utils';


// get all Ads
export const getAllAds = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/ads`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Ads error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Ads failed" }
        };
    }
};